module.exports = __webpack_public_path__ + "static/media/grossArrowDown.53e91aa9.svg";